export default function NoPermission() {
  return (
    <div className="h-full flex items-center justify-center">
      <div className="max-w-lg w-full bg-white border border-gray-200 rounded-xl p-6 text-center shadow-sm">
        <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-yellow-100 text-yellow-700">
          <svg
            className="h-5 w-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="13" />
            <circle cx="12" cy="16" r="0.8" />
          </svg>
        </div>
        <h1 className="text-lg font-semibold text-gray-900 mb-1">접근 가능한 메뉴가 없습니다</h1>
        <p className="text-sm text-gray-600 mb-3">
          현재 계정에는 어떤 페이지에도 접근할 수 있는 권한이 없습니다.
          <br />
          관리자에게 필요한 메뉴 및 원천데이터 프로젝트에 대한 권한을 요청해 주세요.
        </p>
        <p className="text-xs text-gray-400">
          (상단 우측의 로그아웃 버튼으로 계정을 전환할 수 있습니다.)
        </p>
      </div>
    </div>
  )
}


